import React, { forwardRef } from 'react';
import Icon, { generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
const draw16px = 'M2.9 4.61a.73.73 0 0 1 .54.23L8 9.57l4.56-4.73a.75.75 0 1 1 1.08 1l-5.1 5.29a.78.78 0 0 1-.54.27.78.78 0 0 1-.54-.23l-5.1-5.29a.75.75 0 0 1 0-1.06.73.73 0 0 1 .54-.21Z';
const draw24px = 'M12,16.17a.74.74,0,0,1-.54-.23L6.23,10.52a.75.75,0,0,1,1.08-1L12,14.34l4.69-4.86a.75.75,0,1,1,1.08,1l-5.23,5.42A.74.74,0,0,1,12,16.17Z';
const icons = {
  _16: {
    d: draw16px,
    viewBox: VIEWBOXES._16
  },
  _24: {
    d: draw24px,
    viewBox: VIEWBOXES._24
  }
};
const ChevronDownIcon = /*#__PURE__*/forwardRef(generateRenderedIcon(icons, 'chevronDown'));
ChevronDownIcon.displayName = 'ChevronDownIcon';
ChevronDownIcon.propTypes = Icon.propTypes;
ChevronDownIcon.renderIcon = props => /*#__PURE__*/React.createElement(ChevronDownIcon, props);
export default ChevronDownIcon;
//# sourceMappingURL=ChevronDownIcon.js.map